<template>
  <div class="app-layout__page" :class="{ 'app-layout__page--white': linksCount === -1 }">
    <!-- todo; update with CenteredLayout component -->
    <div class="app-hero middle-xs center-xs" :class="{ 'app-hero--fullheight': linksCount > -1 }">
      <section class="wrap">
        <div class="row center-xs">

          <div class="col-xs col-md-8 app-hero__form-wrap">
            <Intro/>
            <UrlInput/>

            <portal-target name="load-meta" />
          </div>

        </div>
      </section>
    </div>

    <section class="app-layout__container">
      <SiftResults />
    </section>

    <portal to="modals">
      <app-modal
        v-if="displayNotFoundError"
        @close="displayNotFoundError = false"
      >
        Unfortunately, this page hasn't been found.
      </app-modal>
    </portal>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import eventBus from '@/event-bus';
import UrlInput from '@/components/Hero/UrlInput/UrlInput.vue';
import Intro from '@/components/Hero/Intro/Intro.vue';
import SiftResults from '@/components/SiftResults/SiftResults.vue';
import Modal from '@/components/UI/Modal.vue';

export default {
  name: 'Home',
  data: function () {
    return {
      displayNotFoundError: false,
    };
  },
  methods: {
    ...mapMutations({
      clearLinks: 'UrlInput/clearLinks',
    }),
  },
  deactivated() {
    eventBus.$emit('tryAgain');
    this.clearLinks();
  },
  created() {
    eventBus.$on('error404', () => {
      this.displayNotFoundError = true;
    });
  },
  components: {
    UrlInput,
    Intro,
    SiftResults,
    appModal: Modal,
  },
  computed: {
    ...mapGetters({
      linksCount: 'UrlInput/siftedWebsiteLinksCount',
      isUserLoggedIn: 'isUserLoggedIn',
    }),
  },
};
</script>
